import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { HydraulicWallForm, HydraulicWallListResponse } from "../types";
import {
  selectHydraulicWallForm,
  selectHydraulicWallPage,
  selectHydraulicWallPerPage,
} from "./selector";
import { hydraulicWallActions } from "./slice";

let isFetchingList = false;

export function* handleGetHydraulicWallList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectHydraulicWallPage);
    const perPage: number = yield select(selectHydraulicWallPerPage);

    const response: HydraulicWallListResponse = yield call(
      request,
      `${API_URL}/hydraulic-type/list?page=${page}&perPage=${perPage}`,
      { method: "GET" },
    );

    const rawData = response?.data || [];
    const meta = getPaginationMeta(page, perPage, rawData, response?.meta);
    const data = rawData.filter((item) =>
      Boolean(String(item?.hydraulicTypeName ?? "").trim()),
    );
    const payload = { data, meta };

    if (page === 1) {
      yield put(hydraulicWallActions.getHydraulicWallListSuccess(payload));
    } else {
      yield put(hydraulicWallActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectHydraulicWallPage);

    if (page === 1) {
      yield put(hydraulicWallActions.getHydraulicWallListError(message));
    } else {
      yield put(hydraulicWallActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddHydraulicWall() {
  const form: HydraulicWallForm = yield select(selectHydraulicWallForm);

  try {
    yield call(request, `${API_URL}/hydraulic-type`, {
      method: "POST",
      body: JSON.stringify({
        hydraulicTypeName: form.description.trim(),
        compareToBump: Number(form.number),
      }),
    });

    yield put(hydraulicWallActions.addHydraulicWallSuccess());
    yield put(hydraulicWallActions.getHydraulicWallList());
  } catch (error) {
    yield put(
      hydraulicWallActions.addHydraulicWallError((error as Error).message),
    );
  }
}

export function* hydraulicWallSaga() {
  yield takeLeading(
    [
      hydraulicWallActions.getHydraulicWallList.type,
      hydraulicWallActions.getNextPageItems.type,
    ],
    handleGetHydraulicWallList,
  );
  yield takeLatest(
    hydraulicWallActions.addHydraulicWall.type,
    handleAddHydraulicWall,
  );
}

export default hydraulicWallSaga;
